<template>
	<v-snackbar
		:value="value"
		:color="color"
		:timeout="timeout"
		:top="top"
		:bottom="bottom"
		:left="left"
		:right="right"
		v-bind="$attrs"
		v-on="$listeners"
	>
		<slot></slot>
	</v-snackbar>
</template>

<script>

export default {
	name: 'KSnackbar',
	inheritAttrs: false,
	props: {
		value: Boolean,
		bottom: Boolean,
		left: Boolean,
		right: Boolean,
		top: Boolean,
		timeout: Number,
		color: String
	},
};
</script>